var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 12.5V2.5C11.8201 6.32833 11.6476 9.4325 11.6667 12.5H15.8334ZM15.8334 12.5V17.5H15.0001V15M6.66675 3.33333V17.5M4.16675 3.33333V5.83333C4.16675 6.49637 4.43014 7.13226 4.89898 7.6011C5.36782 8.06994 6.00371 8.33333 6.66675 8.33333C7.32979 8.33333 7.96567 8.06994 8.43452 7.6011C8.90336 7.13226 9.16675 6.49637 9.16675 5.83333V3.33333",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanteen);
export default __webpack_public_path__ + "static/media/canteen.afe6130490e04e1ebb0a3c725651ff4c.svg";
export { ForwardRef as ReactComponent };